/* eslint-disable no-console */
import "broadcastchannel-polyfill";
import {
    register
} from 'register-service-worker'
//import { BroadcastChannel } from 'broadcast-channel';
if (process.env.NODE_ENV !== 'development') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n' +
                'For more details, visit https://goo.gl/AFskqB'
            )
        },
        cached() {
            console.log('Content has been cached for offline use.')
        },
        updated() {
            console.log('updates applied, refreshing page')
          const broadcast = new BroadcastChannel('update-channel');
          localStorage.setItem('genoUpdated', true)
            setTimeout(() => {
            broadcast.postMessage('reloadPage')
            window.location.reload(true)
            },500)
        },
        registered(registration) {
          console.log( 'Service worker has been registered.')
          const broadcast = new BroadcastChannel('update-channel');
          broadcast.onmessage = (event) => {
              if ( event && event.data && event.data == 'checkUpdates') { 
                console.log('Updating version...')
                registration.update()
                }
                }
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.')
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        }
    })
}
